function activeCardSwatches(){
  var customSwatches = document.querySelectorAll('.color-swatch')
  if (customSwatches.length > 1){
    customSwatches.forEach(customSwatch => {
      customSwatch.addEventListener('click', function(e) {
        var getCard = e.target.closest('.product-block')
        
        /* Update Subtitle */
        var getNewTitle = e.target.getAttribute('data-subtitle')
        var getOldTitle = getCard.querySelector('.subtitle')
        if (getNewTitle != undefined){
          getOldTitle.innerText = getNewTitle
        }

        /* Update Price */
        var getNewPrice = e.target.getAttribute('data-price')
        var getOldPrice = getCard.querySelector('.theme-money')
        if (getNewPrice != undefined){
          getOldPrice.innerText = getNewPrice
        }
        
        /* Update First Image */
        var getNewImage = e.target.getAttribute('data-image-1') 
        var getOldImage = getCard.querySelector('.image__first .rimage__image')
        if (getOldImage != undefined && getNewImage != undefined){
          getOldImage.setAttribute('src', getNewImage)
          getOldImage.setAttribute('srcset', getNewImage)
        }

        /* Update  Images */
        var loopImages = 2;
        var imagesCard = getCard.querySelectorAll('.product-block--slide')
        imagesCard.forEach(imageCard => {
          var getNewImage = e.target.getAttribute('data-image-' + loopImages) 
          if (getNewImage != undefined){
            imageCard.setAttribute('src', getNewImage)
          }

          loopImages++;
        });

        getCard.querySelectorAll('.color-swatch').forEach(customSwatchByCard => {
          customSwatchByCard.classList.remove('color-swatch-selected')
        })
        customSwatch.classList.add('color-swatch-selected')
      });
    });
  }
}

activeCardSwatches()